import o, { css as t } from "styled-components";
import a from "../../utils/colors.js";
import { device as e } from "../../utils/device.js";
const l = o.div`
  min-width: 100%;
  min-height: 320px;
  position: relative;

  @media ${e.isMobile} {
    background: none;
    background-color: ${(i) => i.$backgroundColor || a.orange};
    padding-bottom: 0;
    min-height: 100px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
`, b = o.div`
  letter-spacing: -0.24px;
  color: ${a.white};
  overflow-wrap: break-word;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  z-index: 2;

  @media ${e.isMobile} {
    line-height: 38px;
    margin: 0 20px;
    height: auto;
    width: calc(100% - 40px);
  }

  @media ${e.isTablet} {
    margin: 0 36px;
    min-height: 200px;
    line-height: 46px;
    letter-spacing: -0.27px;
    position: relative;
  }

  @media ${e.isDesktop} {
    margin: 0 auto;
    min-height: 200px;
    width: 1024px;
    padding-top: 44px;
    box-sizing: border-box;
    align-items: unset;
    line-height: 46px;
    letter-spacing: -0.27px;
    position: relative;
  }
`, c = o.h1`
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  width: 100%;
  word-wrap: break-word;

  @media ${e.isTablet} {
    max-width: 50%;
    font-size: 40px;
  }

  @media ${e.isDesktop} {
    max-width: 55%;
    font-size: 40px;
    margin-top: 0;
    margin-bottom: 0;
  }

  @media ${e.isMobile} {
    font-size: 30px;
  }
`, r = o.span`
  background-size: cover;
  position: absolute;
  top: 0;
  left: 50%;
  width: 50%;
  height: 100%;
  display: none;

  @media ${e.isDesktop}, ${e.isTablet} {
    display: block;
  }
`, s = o.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: -1px;
    height: 100%;
    width: 100%;
    background-size: contain;

    @media ${e.isTablet} {
      ${(i) => i.$imgUrl ? t`
              background: linear-gradient(
                110deg,
                ${i.$backgroundColorPrimary || "rgba(227, 113, 10, 1)"} 60%,
                ${i.$backgroundColorSecondary || "rgba(250, 145, 0, 1)"} 60%,
                ${i.$backgroundColorSecondary || "rgba(250, 145, 0, 1)"} 64%,
                transparent 64%
              );
            ` : t`
              background: linear-gradient(110deg, ${i.$backgroundColorPrimary || "rgba(227, 113, 10, 1)"} 50%, ${i.$backgroundColorSecondary || "rgba(250, 145, 0, 1)"} 50%);
            `}
    }

    @media ${e.isDesktop} {
      ${(i) => i.$imgUrl ? t`
              background: linear-gradient(
                110deg,
                ${i.$backgroundColorPrimary || "rgba(227, 113, 10, 1)"} 55%,
                ${i.$backgroundColorSecondary || "rgba(250, 145, 0, 1)"} 55%,
                ${i.$backgroundColorSecondary || "rgba(250, 145, 0, 1)"} 57%,
                transparent 57%
              );
            ` : t`
              background: linear-gradient(110deg, ${i.$backgroundColorPrimary || "rgba(227, 113, 10, 1)"} 55%, ${i.$backgroundColorSecondary || "rgba(250, 145, 0, 1)"} 55%);
            `}
    }
  }

  ${r} {
    background-image: url(${(i) => i.$imgUrl});
  }
`;
export {
  r as Img,
  s as ImgWrapper,
  b as Text,
  c as TextInner,
  l as Wrapper
};
